import React from "react"
import { MainCP } from "../../Components/recuerdo-guiado-marcas/MainCP"

const ViewRecuerdoGuiadoMarcas: React.FC = () => <MainCP/>

export default ViewRecuerdoGuiadoMarcas